<template>
    <ul class="contactInformation">
        <li>
            <el-popover
                placement="left-start"
                trigger="hover">
                <img class="info" src="@/assets/images/about/contact/code_zh.jpg" alt="" style="width:220px;height:220px;">
                <img slot="reference" class="icon" src="@/assets/images/home/pc_10.png" alt="" style="width:60px;height:60px;">
            </el-popover>
            
            <!-- <div class="inner">
                123
            </div> -->
        </li>
        <!-- <li>
            <el-popover
                placement="left"
                trigger="hover">
                <img class="info" src="@/assets/images/home/pc_15.jpg" alt="" style="width:220px;height:220px;">
                <img slot="reference" class="icon" src="@/assets/images/home/pc_11.png" alt="" style="width:60px;height:60px;">
            </el-popover>
        </li> -->
        <li>
            <el-popover
                placement="left-end"
                trigger="hover">
                <a href="tel:17823735848">
                    <div style="width:240px;height:220px;text-align:center;display:flex;align-items:center;justify-content:space-around;">
                            <div>
                                <img style="width:60px;height:60px;" class="info" src="@/assets/images/home/pc_13.png" alt="" >
                                <p style="font-size:32px;color:#333;font-weight: 500;">17823735848</p>
                            </div>
                    </div>
                </a>
                <img slot="reference" class="icon" src="@/assets/images/home/pc_12.png" alt=""  style="width:60px;height:60px;">
            </el-popover>
        </li>
    </ul>
</template>
<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>
<style lang="less" scoped>
.contactInformation{
    // width:80px;
    background: #ffffff;
    border: 1px solid #cccccc;
    position: fixed;
    z-index: 998;
    right:5%;
    bottom: 20%;
    li{
        padding:10px;
        position: relative;
    }
    li::after{
        content: "";
        border-bottom:1px solid #ccc;
        position: absolute;
        width:70%;
        bottom:0;
        left:15%;
    }
    li:last-child::after{
        content: "";
        border-bottom: none;
    }
    .icon{
        width:60px;
        height: 60px;
        cursor: pointer;
    }
}
</style>